export default __webpack_public_path__ + "static/media/offer2.a053f5f8.png";